import React from 'react';
import { Link } from 'react-router-dom';

const Navi = (props) => {
	return (
		<>
			<h3>Navi page</h3>
			<ul>
				<Link to="/sample/product/1"><li>1번상품</li></Link>
				<Link to="/sample/product/2"><li>2번상품</li></Link>
			</ul>
		</>
	);
};

export default Navi;